"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = Loader;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
function Loader(_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, className = _a.className;
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, react_1.cn)("flex w-full items-center justify-center py-8", className), children: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: size, color: "accent" }) }));
}
